import BaseService from "./Base.Service";

class ContractPatternService extends BaseService {
  constructor() {
    const model = {
      name: { type: String, required: true },
      invoice_deadline: { type: Number, required: true },
      invoice_deadline_type: { type: String, required: true },
      payment_rule_type: { type: String, required: true },
    };
    super("contract-patterns", model);
  }

  /**
   * Duplicar um padrão existente
   * @param {number} id
   * @returns {Promise}
   */
  async duplicate(id) {
    const { data } = await this.conn.axios.post(`/contract-patterns/${id}/duplicate`);
    return data;
  }
}

export default ContractPatternService;
